// @utils/api/organizations/use-add-export-template.tsx
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import {
  ExportTemplatePayload,
  Template
} from '@utils/types/organization/export-template.ts';

const postExportTemplate = (payload: ExportTemplatePayload) => {
  const formData = new FormData();
  formData.append('name', payload.name);

  if (payload.template_type) {
    formData.append('template_type', payload.template_type);
  }

  if (payload.template_docx) {
    formData.append('docx_template', payload.template_docx);
  }
  if (payload.template_example) {
    formData.append('example_template', payload.template_example);
  }

  // Always send prompt, even if empty or null - user's input is final
  if (payload.prompt !== undefined && payload.prompt !== null) {
    formData.append('prompt', payload.prompt);
  }

  return Axios.post<Template>(POST_URL().exportTemplates, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(res => res.data);
};

export const useAddExportTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation<Template, AxiosError<BaseError>, ExportTemplatePayload>(
    postExportTemplate,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QueryKeys.exportTemplates());
      },
      useErrorBoundary: false
    }
  );
};
